import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Config } from "app/components/auth-provider/duck/types";
import { offlineActions } from "configs";
import { useGetApplicationSettingsQuery } from "requests";
import { setErrorsFromResponse } from "../utils";
import useInitializeOfflineMode from "./use-initialize-offline-mode";
import useOnline from "./useOnline";

export const useAuthenticate = ({
  setConfig,
  skip,
  onCompleted
}: {
  setConfig: React.Dispatch<Config>;
  skip?: boolean;
  onCompleted?(organizationId?: number): void;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const online = useOnline();

  const initialize = useInitializeOfflineMode();

  useGetApplicationSettingsQuery({
    skip,
    onCompleted(response) {
      const user = response.applicationSettings?.user;
      if (!user) {
        setConfig({ loading: false, user: null } as any);
        return;
      }
      setConfig({ loading: false, user });
      initialize(user);

      if (onCompleted) {
        onCompleted(user.organization?._id);
      }
    },
    onError(error) {
      if (!error) {
        dispatch(offlineActions.setOnline(false));
      }

      setErrorsFromResponse(error);

      setConfig({ loading: false, user: null } as any);

      if (!online) {
        navigate("/pin", { replace: true });
      }
    },
    fetchPolicy: "no-cache"
  });
};

export default useAuthenticate;
